const TiptapMenu = ({editor}) => {
    // Empêche le mousedown par défaut : sans ça, cliquer sur un bouton de la barre d'outils fait
    // perdre la sélection de texte dans l'éditeur avant même que le clic ne s'exécute, donc le
    // formatage (gras, italique...) ne s'applique pas au texte sélectionné.
    const preventFocusLoss = (e) => e.preventDefault();

    const addLink = () => {
        const url = prompt('Enter the URL');
        if (url) {
            editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
        }
    };

    return (
        <div className="flex tiptap-menu column">
            <div className="control-group">
                {/*<div className="button-group flex">
                    <button>Tableau</button>
                    <button type="button" onClick={() => editor.chain().focus().insertTable({
                        rows: 3,
                        cols: 3,
                        withHeaderRow: true
                    }).run()}>
                        <i className="fa fa-table"/>
                    </button>
                    <button type="button" onClick={() => editor.chain().focus().addColumnBefore().run()}
                            disabled={!editor.can().addColumnBefore()}>
                        <i className="fa fa-arrow-left"/><i className="fa fa-columns"/>
                    </button>
                    <button type="button" onClick={() => editor.chain().focus().addColumnAfter().run()}
                            disabled={!editor.can().addColumnAfter()}>
                        <i className="fa fa-columns"/><i className="fa fa-arrow-right"/>
                    </button>
                    <button type="button" onClick={() => editor.chain().focus().deleteColumn().run()}
                            disabled={!editor.can().deleteColumn()}>
                        <i className="fa fa-columns"/><i className="fa fa-close"/>
                    </button>
                    <button type="button" onClick={() => editor.chain().focus().addRowBefore().run()}
                            disabled={!editor.can().addRowBefore()}>
                        <i className="fa fa-arrow-up"/><i className="fa fa-table-cells-large"/>
                    </button>
                    <button type="button" onClick={() => editor.chain().focus().addRowAfter().run()}
                            disabled={!editor.can().addRowAfter()}>
                        <i className="fa fa-arrow-down"/><i className="fa fa-table-cells-large"/>
                    </button>
                    <button type="button" onClick={() => editor.chain().focus().deleteRow().run()}
                            disabled={!editor.can().deleteRow()}>
                        <i className="fa fa-table-cells-large"/><i className="fa fa-close"/>
                    </button>
                    <button type="button" onClick={() => editor.chain().focus().deleteTable().run()}
                            disabled={!editor.can().deleteTable()}>
                        <i className="fa fa-table"/><i className="fa fa-close"/>
                    </button>
                    <button type="button" onClick={() => editor.chain().focus().mergeCells().run()}
                            disabled={!editor.can().mergeCells()}>
                        <i className="fa fa-arrow-right"/>|<i className="fa fa-arrow-left"/>
                    </button>
                    <button type="button" onClick={() => editor.chain().focus().splitCell().run()}
                            disabled={!editor.can().splitCell()}>
                        <i className="fa fa-arrow-left"/>|<i className="fa fa-arrow-right"/>
                    </button>
                    <button type="button" onClick={() => editor.chain().focus().goToNextCell().run()}
                            disabled={!editor.can().goToNextCell()}>
                        <i className="fa fa-arrow-right"/>
                    </button>
                    <button type="button" onClick={() => editor.chain().focus().goToPreviousCell().run()}
                            disabled={!editor.can().goToPreviousCell()}>
                        <i className="fa fa-arrow-left"/>
                    </button>
                </div>*/}
            </div>
            <div className="control-group flex">
                <span>Mise en forme |</span>
            <button type="button"
                    onMouseDown={preventFocusLoss}
                    onClick={() => editor.chain().focus().toggleBold().run()}
                    disabled={
                        !editor.can()
                            .chain()
                            .focus()
                            .toggleBold()
                            .run()
                    }
                    className={editor.isActive('bold') ? 'is-active' : ''}>
                <strong>B</strong>
            </button>
            <button type="button"
                    onMouseDown={preventFocusLoss}
                    onClick={() => editor.chain().focus().toggleItalic().run()}
                    disabled={
                        !editor.can()
                            .chain()
                            .focus()
                            .toggleItalic()
                            .run()
                    }
                    className={editor.isActive('italic') ? 'is-active' : ''}
            >
                Italic
            </button>
            <button type="button"
                    onMouseDown={preventFocusLoss}
                    onClick={() => editor.chain().focus().toggleUnderline().run()}
                    className={editor.isActive('underline') ? 'is-active' : ''}
            >
                <u>U</u>
            </button>
            <button type="button"
                    onMouseDown={preventFocusLoss}
                    onClick={() => editor.chain().focus().toggleStrike().run()}
                    disabled={
                        !editor.can()
                            .chain()
                            .focus()
                            .toggleStrike()
                            .run()
                    }
                    className={editor.isActive('strike') ? 'is-active' : ''}
            >
                <strike>S</strike>
            </button>
            <input
                type="color"
                onMouseDown={preventFocusLoss}
                onInput={event => editor.chain().focus().setColor(event.target.value).run()}
                value={editor.getAttributes('textStyle').color || '#000000'}
                data-testid="setColor"
            />
            <button type="button"
                    onMouseDown={preventFocusLoss}
                    onClick={() => editor.chain().focus().unsetColor().run()}
                    data-testid="unsetColor"
            >
                Supprimer la couleur
            </button>
            <button type="button"
                    onMouseDown={preventFocusLoss}
                    onClick={() => editor.chain().focus().toggleHeading({level: 1}).run()}
                    className={editor.isActive('heading', {level: 1}) ? 'is-active' : ''}
            >
                Titre H1
            </button>
            <button type="button"
                    onMouseDown={preventFocusLoss}
                    onClick={() => editor.chain().focus().toggleHeading({level: 2}).run()}
                    className={editor.isActive('heading', {level: 2}) ? 'is-active' : ''}
            >
                Titre H2
            </button>
            {/*<button type="button"
                    onClick={() => editor.chain().focus().toggleHeading({level: 3}).run()}
                    className={editor.isActive('heading', {level: 3}) ? 'is-active' : ''}
            >
                Titre H3
            </button>
            <button type="button"
                    onClick={() => editor.chain().focus().toggleBulletList().run()}
                    className={editor.isActive('bulletList') ? 'is-active' : ''}
            >
                <i className="fa fa-list-ul"/>
            </button>
            <button type="button"
                    onClick={() => editor.chain().focus().toggleOrderedList().run()}
                    className={editor.isActive('orderedList') ? 'is-active' : ''}
            >
                <i className="fa fa-list-ol"/>
            </button>
            <button type="button" onClick={() => editor.chain().focus().setHorizontalRule().run()}>
                _
            </button>
            <button type="button" onClick={() => editor.chain().focus().setHardBreak().run()}>
                Passer ligne
            </button>
            <button type="button"
                    onClick={() => editor.chain().focus().undo().run()}
                    disabled={
                        !editor.can()
                            .chain()
                            .focus()
                            .undo()
                            .run()
                    }
            >
                <i className="fa fa-rotate-left"/>
            </button>
            <button
                onClick={() => editor.chain().focus().redo().run()}
                disabled={
                    !editor.can()
                        .chain()
                        .focus()
                        .redo()
                        .run()
                }
            >
                <i className="fa fa-rotate-right"/>
            </button>
            <button type="button" onClick={addLink} className="menu-button">
                Add Link
            </button>*/}
        </div>
        </div>
    )
}

export default TiptapMenu;